/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 143);
/******/ })
/************************************************************************/
/******/ ({

/***/ 143:
/***/ (function(module, exports) {

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LiftoffDebugger = function () {
  function LiftoffDebugger() {
    _classCallCheck(this, LiftoffDebugger);
  }

  _createClass(LiftoffDebugger, null, [{
    key: "init",
    value: function init(debuggerContext) {
      this.el = document.createElement("div");
      this.el.classList.add("liftoff-debugger");
      Object.assign(this.el.style, {
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 9999,
        fontSize: "12px",
        background: "aqua",
        minWidth: "15px",
        minHeight: "15px",
        overflowY: "auto",
        userSelect: "none",
        opacity: 0.9
      });

      this.debuggerContext = debuggerContext;
      this.viewportSizes = [];
      this.showing = true;

      this.addEventListeners();
      this.testViewport();
      this.render();

      document.body.appendChild(this.el);
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this = this;

      window.addEventListener("resize", function () {
        if (_this.testViewport()) _this.render();
      });

      this.el.addEventListener("click", function () {
        _this.showing = !_this.showing;
        _this.el.style.display = _this.showing ? "block" : "none";
      });
    }
  }, {
    key: "testViewport",
    value: function testViewport() {
      var _window = window,
          width = _window.innerWidth,
          height = _window.innerHeight;

      var len = this.viewportSizes.length;

      var _ref = len > 0 ? this.viewportSizes[len - 1] : [-1, -1],
          _ref2 = _slicedToArray(_ref, 2),
          lastWidth = _ref2[0],
          lastHeight = _ref2[1];

      if (width !== lastWidth || height !== lastHeight) {
        this.viewportSizes.push([width, height]);
        this.el.style.maxHeight = height;
        return true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _debuggerContext = this.debuggerContext,
          ab_tests = _debuggerContext.ab_tests,
          bid_request_id = _debuggerContext.bid_request_id,
          creative_id = _debuggerContext.creative_id,
          exchange = _debuggerContext.exchange,
          platform = _debuggerContext.platform,
          viewclick_html_interstitial = _debuggerContext.viewclick_html_interstitial,
          viewclick_vast_interstitial = _debuggerContext.viewclick_vast_interstitial,
          use_ios_pod = _debuggerContext.use_ios_pod,
          use_liftoff_pod = _debuggerContext.use_liftoff_pod,
          targeted_countries = _debuggerContext.targeted_countries;


      var liftoffMRAID = window.Liftoff && window.Liftoff.LiftoffMRAID || window.LiftoffMRAID;
      var supportsMraid = liftoffMRAID != null ? liftoffMRAID.hasSupport("mraid") : window.mraid != null;
      var umbrellaInfo = (viewclick_html_interstitial ? "viewclick-html" : "") + "\n    " + (viewclick_vast_interstitial ? "viewclick-vast" : "") + "\n    " + (use_ios_pod ? "use-ios-pod" : "") + "\n    " + (use_liftoff_pod ? "use-liftoff-pod" : "") + "\n    ";
      this.el.innerHTML = "\n    br_id " + bid_request_id + "<br>\n    " + creative_id + " " + (exchange || "") + " " + platform + " " + (supportsMraid ? "MRAID" : "") + "<br>\n    " + this.viewportSizes.map(function (s) {
        return s ? s.join("x") : "?";
      }).join(" ") + "<br>\n    " + (umbrellaInfo.trim() === "" ? "" : umbrellaInfo + "<br>") + "\n    " + (ab_tests ? ab_tests.join("<br>") : "") + "\n    " + (targeted_countries ? targeted_countries.join(" ") : "") + "\n    ";
    }
  }]);

  return LiftoffDebugger;
}();

window.LiftoffDebugger = LiftoffDebugger;

/***/ })

/******/ });


// WEBPACK FOOTER //
// liftoff_debugger-e374ac7193ea5a12dfe6.js